export interface IDocumentPublishResult {
    message: string;
    rowId: string;
    publishedId: string;
    publishVersion: number;
}

export class DocumentPublishResult implements IDocumentPublishResult {
    message: string;
    rowId: string;
    publishedId: string;
    publishVersion: number;

    constructor();
    constructor(obj: IDocumentPublishResult);
    constructor(obj?: any) {
        this.message = obj && obj.message || "";
        this.rowId = obj && obj.rowId || "";
        this.publishVersion = obj && obj.publishVersion || 0;
        this.publishedId = obj && obj.publishedId || "";
    }
}